import {
  Paper,
  SimpleGrid,
  Stack,
  Text,
  Title,
  Table,
  NumberFormatter,
  Anchor,
  Tooltip,
} from "@mantine/core";
import { isCitedPublisher } from "../../_Shared/domains";
import classes from "./StatsOverview.module.css";

export default function StatsOverview({ stats }) {
  if (!stats) return null;

  const topBrands = Object.entries(stats.brandMentions || {});
  // .sort((a, b) => b[1] - a[1])
  // .slice(0, 10);

  const topKeywords = Object.entries(stats.keywordMentions || {});
  // .sort((a, b) => b[1] - a[1])
  // .slice(0, 10);

  const topSourceUrls = Object.entries(stats.topSources || {}).filter(([source]) =>
    isCitedPublisher(source),
  );
  const topDomains = Object.entries(stats.topDomains || {}).filter(([source]) =>
    isCitedPublisher(source),
  );
  const hasSources = topSourceUrls.length > 0 || topDomains.length > 0;

  return (
    <Stack mt="sm">
      {/* <Title order={4}>Snapshot Statistics</Title> */}

      <SimpleGrid cols={4}>
        <Paper
          className={classes.statBox}
          ta="center"
          withBorder
          shadow="xs"
          p="xs"
        >
          <Text size="sm" c="dimmed">
            Average Rank
          </Text>
          <Text fw={700}>{stats.averageRank?.toFixed(1) || "N/A"}</Text>
        </Paper>

        <Paper
          className={classes.statBox}
          ta="center"
          withBorder
          shadow="xs"
          p="xs"
        >
          <Text size="sm" c="dimmed">
            Share of Voice (Unaided)
          </Text>
          <Text fw={700}>
            {stats.shareOfVoiceUnaided
              ? (stats.shareOfVoiceUnaided * 100).toFixed(1) + "%"
              : "N/A"}
          </Text>
        </Paper>

        <Paper
          className={classes.statBox}
          ta="center"
          withBorder
          shadow="xs"
          p="xs"
        >
          <Text size="sm" c="dimmed">
            Share of Voice (Aided)
          </Text>
          <Text fw={700}>
            {(stats.shareOfVoiceAided * 100)?.toFixed(1) || "0"}%
          </Text>
        </Paper>

        <Paper
          className={classes.statBox}
          ta="center"
          withBorder
          shadow="xs"
          p="xs"
        >
          <Text size="sm" c="dimmed">
            Average Reputation
          </Text>
          <Text fw={700}>{stats.averageReputation?.toFixed(2) || "N/A"}</Text>
        </Paper>
      </SimpleGrid>

      <SimpleGrid cols={hasSources ? 3 : 2}>
        <Paper withBorder shadow="xs" p="md">
          <Title order={5} mb="sm">
            Top Brands
          </Title>
          {topBrands.length > 0 ? (
            <Table size="sm" tabularNums>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Brand</Table.Th>
                  <Table.Th ta="right">Mentions</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {topBrands.slice(0, 5).map(([brand, count]) => (
                  <Table.Tr key={brand}>
                    <Table.Td>{brand}</Table.Td>
                    <Table.Td ta="right">
                      <NumberFormatter value={count} thousandSeparator />
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Text c="dimmed">No brand mentions found</Text>
          )}
        </Paper>

        {hasSources && (
          <Paper withBorder shadow="xs" p="md">
            <Title order={5} mb="sm">
              Top Sources
            </Title>
            <Table tabularNums size="sm">
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Source</Table.Th>
                  <Table.Th ta="right">Referenced</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {(topSourceUrls.length > 0 ? topSourceUrls : topDomains)
                  .slice(0, 5)
                  .map(([source, count]) => {
                    const isUrl = source.startsWith("http");
                    let domain = source;
                    try {
                      if (isUrl) domain = new URL(source).hostname;
                    } catch {}
                    return (
                      <Table.Tr key={source}>
                        <Table.Td style={{ maxWidth: 200 }}>
                          {isUrl ? (
                            <Tooltip label={source} multiline maw={400}>
                              <Anchor
                                href={source}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="sm"
                                truncate="end"
                                style={{ display: "block" }}
                              >
                                {domain}
                              </Anchor>
                            </Tooltip>
                          ) : (
                            <Text size="sm" truncate="end">
                              {source}
                            </Text>
                          )}
                        </Table.Td>
                        <Table.Td ta="right">
                          <NumberFormatter value={count} thousandSeparator />
                        </Table.Td>
                      </Table.Tr>
                    );
                  })}
              </Table.Tbody>
            </Table>
          </Paper>
        )}

        <Paper withBorder shadow="xs" p="md">
          <Title order={5} mb="sm">
            Top Keywords
          </Title>
          {topKeywords.length > 0 ? (
            <Table tabularNums size="sm">
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Keyword</Table.Th>
                  <Table.Th ta="right">Mentions</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {topKeywords.slice(0, 5).map(([keyword, count]) => (
                  <Table.Tr key={keyword}>
                    <Table.Td>{keyword}</Table.Td>
                    <Table.Td ta="right">
                      <NumberFormatter value={count} thousandSeparator />
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Text c="dimmed">No keywords found</Text>
          )}
        </Paper>
      </SimpleGrid>
    </Stack>
  );
}
